'use-client';
import * as React from 'react';
import { replaceCompIdPlaceholderInSvgContent } from '@wix/editor-elements-common-utils';
import VectorImage from '@wix/editor-elements-library/src/components/VectorImage/viewer/VectorImage';
import type { VideoBoxPlayProps } from '../../VideoBox/VideoBox.types';
import styles from '../../VideoBox/viewer/style/VideoBox.scss';

const VideoBoxPlay: React.FC<VideoBoxPlayProps> = ({
  id,
  vectorImageProps,
  shouldRender,
  reducedMotion = false,
  className,
  isClassNameToRootEnabled,
}) => {
  replaceCompIdPlaceholderInSvgContent(vectorImageProps, id);

  const rootClassName = isClassNameToRootEnabled ? className : '';

  return (
    <div id={id} className={rootClassName}>
      {(shouldRender || reducedMotion) && (
        <div className={styles.videoPlayPauseIcon}>
          <div className={styles.videoboxPause} data-testid="pause-icon">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="13"
                y="10"
                width="5"
                height="20"
                data-color="1"
                fill="white"
                data-testid="pause-rect"
              />
              <rect
                x="22"
                y="10"
                width="5"
                height="20"
                data-color="1"
                fill="white"
                data-testid="pause-rect"
              />
            </svg>
          </div>
          <VectorImage
            id={`play-${id}`}
            className={styles.videoboxPlay}
            data-testid="play-icon"
            {...vectorImageProps}
          />
        </div>
      )}
    </div>
  );
};

export default VideoBoxPlay;
